import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  actions: {
    loadLastestRateItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/wageRates/lastestRates`)
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/wageRates/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/wageRates`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/wageRates/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/wageRates/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/wageRate.js